import { types } from 'mobx-state-tree'
import Player from '../components/Player';
import { COLORS } from '../constants'

export enum PlayerState {
  inactive = 'inactive',
  loading = 'loading',
  loaded = 'loaded',
  playing = 'playing',
  paused = 'paused',
  ended = 'ended',
  completed = 'completed'
}

export const PlayerStore = types.model('PlayerStore', {
  cardIndex: 0,
  eventIndex: 0,
  playerOneColor: '#000',
  playerTwoColor: '#000',
  progressPercentage: 0,
  state: types.optional(
    types.enumeration('PlayerState', Object.keys(PlayerState)),
    PlayerState.inactive
  ),
}).actions(self => {
  const actions = {
    reset() {
      self.state = PlayerState.inactive
      self.cardIndex = 0
      self.eventIndex = 0
      self.progressPercentage = 0
      self.playerOneColor = '#000'
      self.playerTwoColor = '#000'
    },
    setPlayerState(newState: PlayerState) {
      self.state = newState
    },
    setCardIndex (index: number) {
      self.cardIndex = index
    },
    setEventIndex (index: number) {
      self.eventIndex = index
    },
    updateProgressPercentage (percentage: number) {
      percentage = Math.max(0, percentage)
      percentage = Math.min(100, percentage)

      self.progressPercentage = percentage
    },
    loadRandomPlayerColors () {
      const color = COLORS[Math.floor(Math.random() * COLORS.length)]
      let color2 = COLORS[Math.floor(Math.random() * COLORS.length)]

      while (color2 === color) {
        color2 = COLORS[Math.floor(Math.random() * COLORS.length)]
      }

      self.playerOneColor = color
      self.playerTwoColor = color2
    }
  }

  return actions
})

export type IPlayerStore = typeof PlayerStore.Type


// WEBPACK FOOTER //
// ./src/models/player.ts